module.exports = __webpack_public_path__ + "img/fangke.25142484.jpg";